import { Component } from '../../types';
import api from '../../utils/api';

export const createComponent = (variables: Component) =>
  api.post({
    url: `/component`,
    variables,
  });
